// import React, { Component } from "react";

////////////////////// Service Template Head  /////////////////////////

let privateState = {}; // private variables for this service.
// let alreadyInitiated = false;
let service = {};

////////////////////// End Service Template Head  /////////////////////////

////////////////////// Start Service Implementation:  /////////////////////////
// Set the name of the hidden property and the change event for visibility
privateState.permanentCallbackFunctions = {}; // key: someId to enable delete; value: callback function.

service.hidden = undefined;
service.visibilityChange = undefined;

if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  service.hidden = 'hidden';
  service.visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  service.hidden = 'msHidden';
  service.visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  service.hidden = 'webkitHidden';
  service.visibilityChange = 'webkitvisibilitychange';
}
service.init = function () {
  service.visibilityIsHidden = false;
  if (document[service.hidden]) {
    service.visibilityIsHidden = true;
  }
  privateState.permanentCallbackFunctions = {};
  if (
    typeof document.addEventListener === 'undefined' ||
    service.hidden === undefined
  ) {
    // Warn if the browser doesn't support addEventListener or the Page Visibility API

    console.error(
      'This requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.',
    );
  } else {
    // Handle page visibility change
    document.addEventListener(
      service.visibilityChange,
      handleVisibilityChangeEvent,
      false,
    );
  }
};

function handleVisibilityChangeEvent() {
  service.visibilityIsHidden = false;
  if (document[service.hidden]) {
    service.visibilityIsHidden = true;
  }
  const permanentFuncKeys = Object.keys(
    privateState.permanentCallbackFunctions,
  );

  for (
    var index = 0, length = permanentFuncKeys.length;
    index < length;
    index++
  ) {
    privateState.permanentCallbackFunctions[permanentFuncKeys[index]](
      service.visibilityIsHidden,
    );
  }
}
service.doWhenVisibilityChange = function (callbackFunction) {
  const callbackFunctionId =
    new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
  // console.debug("adding connectionEventListener");
  privateState.permanentCallbackFunctions[
    callbackFunctionId
  ] = callbackFunction;
  return () => {
    delete privateState.permanentCallbackFunctions[callbackFunctionId];
  };
};
service.getIsVisibilityHidden = function () {
  return service.visibilityIsHidden;
};

service.init();
const visibilityHandlerService = {...service};
export default visibilityHandlerService;
